<script>
export default {
  name: 'Loading',
  props: {
    text: {
      type: String,
      default: '加载中...'
    },
    iconColor: {
      type: String,
      default: ''
    },
    textColor: {
      type: String,
      default: ''
    }
  }
}
</script>

<template>
  <div class="loading-container">
    <i class="el-icon-loading" :style="{color: iconColor}" />
    <p class="loading-text" :style="{color: iconColor}">{{ text }}</p>
  </div>
</template>

<style lang="scss" scoped>
.loading-container {
  display: flex;
  align-items: center;
  column-gap: 10px;
  .el-icon-loading {
    font-size: 20px;
  }
  .loading-text {
    font-size: 18px;
    line-height: 0;
  }
}
</style>
